<div class="sales-capacity-even-align">
<section class="sales-transport-container">
    <div class="capacity-header">{{'departmentCapacity.remoteSalesAppointmentCapacitySetup'| translate}}
        <div class="controls">
            <div class="cancel"(click)="onCancelClicked()" [ngClass]="isRemoteMaxSlotsPerDayEdited ||isRemoteMaxSlotsPerTimeTableEdited ?'enabled':''">{{'overrideCapacity.cancel'| translate}}</div>
            <div class="save" (click)="onSaveClicked()" [ngClass]="isRemoteMaxSlotsPerDayEdited ||isRemoteMaxSlotsPerTimeTableEdited ?'enabled':''">{{'overrideCapacity.save'| translate}}</div>
        </div>
    </div>
<div style="padding-left: 1rem;">
    <app-transport-max
    [viewMode]="viewMode"
    [transportMaxTotal$]="remoteMaxTotal$ | async"
    (saveChanges)="onTotalSaveChanges($event)"
    [switchInput]=true
    [saveClicked]="isRemoteSlotsPerDaySaveClicked"
    [cancleClicked]="isCancelClicked"
    (formEdited)="remoteMaxSlotsPerDayFormEdited($event)"
    (cancleClick)="resetCancleClickValue($event)"
    (saveClick)="resetSaveClickedValue($event)">
    </app-transport-max>
</div>
</section>



<div class="transport-max-header" >
  {{'transportCapacity.remoteMaxSlotsPerTimePeriod'| translate}}
</div>
<div  class="d-flex table-value-info">
    <div><span class="material-icons" >info</span></div>
        <div class="d-flex" *ngFor="let info of tableValueInfo; last as isLast">
            <div>{{ info.value | translate}}</div> &nbsp; -  &nbsp;<div>{{info.description | translate }}</div>
            <div class="dot-space" *ngIf="!isLast"> | </div> 
        </div>
</div>

<div style="padding:1rem; overflow-y: scroll; ">
    <app-timeslot-grid *ngIf="masterSlotsLoading$ | async" 
        [viewMode]="viewMode"
        [slotDetails$] = "slotDetails$ | async"
        [maxAndMasterSlots$] = "maxAndMasterSlots$ | async"
        (saveChanges)="onSlotsSaveChanges($event)"
        [switchInput]=true
        [saveClicked]="isSavedClicked"
        (formEdited)="remoteMaxSlotsPerTimeTableFormEdited($event)"
        [cancleClicked]="isRemoteMaxSlotsPerTimeTableCancleClicked"
        (cancleClick)="resetCancleClickedPerTimePeriod($event)">
    </app-timeslot-grid>
</div>
</div>
